import { render, staticRenderFns } from "./Qyjybg.vue?vue&type=template&id=700a32c2&scoped=true&"
import script from "./Qyjybg.vue?vue&type=script&lang=js&"
export * from "./Qyjybg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a32c2",
  null
  
)

export default component.exports